import { i18next } from '@frontend/i18n';
import { MAX_CHARACTER_LIMIT, LINK_CANT_BE_SENT_MESSAGE } from '../utils/constants';

const ns = 'thread-sending-area';

export const getErrorNotificationMessage = ({
  isCompact,
  showInlineNotificationLabel,
  isOverCharLimit,
  hasShortenedUrl,
  charCount,
}: {
  isCompact: boolean;
  showInlineNotificationLabel: boolean;
  isOverCharLimit: boolean;
  hasShortenedUrl: boolean;
  charCount: number;
}): string => {
  switch (true) {
    case isCompact || showInlineNotificationLabel:
      return '';

    case isOverCharLimit && hasShortenedUrl:
      return '2';

    case isOverCharLimit:
      return i18next.t(`{{current}} / {{max}}`, {
        ns,
        current: charCount,
        max: MAX_CHARACTER_LIMIT,
      });

    case hasShortenedUrl:
      return i18next.t(LINK_CANT_BE_SENT_MESSAGE, { ns });

    default:
      return '';
  }
};
